import React from 'react';
import { Modal, Input, Button, Alert } from 'rizzui';

interface CloneRouteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  routeName: string;
  onRouteNameChange: (name: string) => void;
  isLoading?: boolean;
}

export const CloneRouteModal: React.FC<CloneRouteModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  routeName,
  onRouteNameChange,
  isLoading = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      overlayClassName="dark:bg-opacity-40 dark:backdrop-blur-md"
      containerClassName="dark:bg-gray-100"
    >
      <div className="p-6">
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-700">
            Clonar Ruta
          </h3>
        </div>
        
        <div className="space-y-4 mb-6">
          <Alert
            color="warning"
            variant="outline"
            className="mb-4"
          >
            <p className="text-sm text-gray-700 break-words">
              <strong>Atención:</strong> Al clonar esta ruta, las sedes asociadas se <br/>transferirán desde la ruta original a la nueva ruta clonada.
            </p>
          </Alert>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-600">
              Nombre de la nueva ruta
            </label>
            <Input
              type="text"
              value={routeName}
              onChange={(e) => onRouteNameChange(e.target.value)}
              placeholder="Ingrese el nombre de la nueva ruta"
              className="w-full"
            />
          </div>
        </div>

        <div className="flex justify-end space-x-3">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={isLoading}
            className="dark:border-gray-300 dark:text-gray-700"
          >
            Cancelar
          </Button>
          <Button
            onClick={onConfirm}
            disabled={!routeName.trim() || isLoading}
            className="bg-blue-600 hover:bg-blue-700 text-white"
          >
            {isLoading ? 'Clonando...' : 'Clonar'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CloneRouteModal;